import { useState } from "react";
import { ConfirmCodeForm } from "./components/ConfirmCodeForm";
import { ForgotPasswordForm } from "./components/ForgotPasswordForm";
import { LoginForm } from "./components/LoginForm";
import { NewPasswordForm } from "./components/NewPasswordForm";

export const SignIn = () => {
  const [isForgotPassword, setIsForgotPassword] = useState<boolean>(false);
  const [isConfirm, setIsConfirm] = useState<boolean>(false);

  const [login, setLogin] = useState<string | null>(null);
  const [code, setCode] = useState<string | null>(null)

  if(login && code) {
    return (
      <NewPasswordForm
        login={login}
        code={code}
      />
    )
  }

  if(isConfirm && login) {
    return (
      <ConfirmCodeForm
        login={login}
        setIsConfirm={setIsConfirm}
        setCode={setCode}
      />
    )
  }

  if(isForgotPassword) {
    return (
      <ForgotPasswordForm
        setLogin={setLogin}
        setIsConfirm={setIsConfirm} 
        setIsForgotPassword={setIsForgotPassword} 
      />
    )
  }
  return <LoginForm setIsForgotPassword={setIsForgotPassword} />;
}